// extracted by mini-css-extract-plugin
export default {"main":"paymentItem_main__Ah2n0","main1":"paymentItem_main1__o0AZR","main2":"paymentItem_main2__ozaun"};